module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('va-small-box', {
    staticClass: "info-box box-yellow",
    attrs: {
      "icon": "ion-chatbubbles ",
      "title": _vm.totalInterestAmt,
      "description": "Total Interest"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b831f78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/interestbalance.vue
// module id = 773
// module chunks = 0